// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__8tgXc","meals-appear":"AvailableMeals_meals-appear__BTha4"};